
import { graphql, PageProps, useStaticQuery } from "gatsby"
import { IMissionSection, IHistorySection, IAboutUsSection, IEventsSection, ITimelineSection, IManagmentSection, IAdressDataSection, ILawInformationsSection, IContactAccountsSection } from "interfaces/sections"
import { Brand, Csr, Information, Person, Post } from "types"
import OpenGraph from "types/opengraph"
import { StringMappingType } from "typescript"
import Media from "../types/media"


export type ContactPageData = {
  adressData: IAdressDataSection,
  openGraph: OpenGraph,
  lawInformations: ILawInformationsSection,
  contactAccounts: IContactAccountsSection
}

const useContactPageData = (): ContactPageData => {
  const { allWpPage } = useStaticQuery(graphql`
  query {
    allWpPage(filter: {slug: {eq: "kontakt"}}) {
      nodes {
        id
        title,
        adressdata{
          active: adressdataactive
          adressdata: data{
            ...on WpAdressdata{
              addressdataOptions{
                description
                image{
                  mediaItemUrl
                  mimeType
                  mediaType
                  altText
                  title
                  gatsbySvg: localFile {
                    publicURL
                  }
                  gatsbyImage: localFile {
                    childImageSharp {
                      gatsbyImageData(
                        width: 800
                        placeholder: BLURRED
                        formats: [AUTO, WEBP]
                      )
                    }
                  }
                }
              }
            }
          }
        }
        lawInformations{
          active: lawinformationsactive
          lawinformations: lawinformationsdata{
            ...on WpLawinformation{
              lawinformationOptions{
                title
                description
              }
            }
          }
        }
        contactAccounts{
          active: contactacountsactive
          accounts{
            ...on WpContactAccount{
              contactAccountOptions{
                title
                email
              }
            }
          }
        }
        openGraphOptions{
          title: ogtitle
          description: ogdescription
          metatitle
          metadescription
          image: ogimage{
            mediaItemUrl
            mimeType
            mediaType
            altText
            title
            gatsbyImage: localFile {
              childImageSharp {
                gatsbyImageData(
                  width: 800
                  placeholder: BLURRED
                  formats: [AUTO, WEBP]
                )
              }
            }
          }
        }
      } 
    }
  }`)
  const pageData = allWpPage.nodes[0]
  return {
    adressData: pageData.adressdata,
    openGraph: pageData.openGraphOptions,
    lawInformations: pageData.lawInformations,
    contactAccounts: pageData.contactAccounts
  }
}

export default useContactPageData